import { c as _c } from "react/compiler-runtime";
import { useMount, useObservable } from '@legendapp/state/react';
export function useMediaQuery$(queryInput, t0) {
  const $ = _c(3);
  const defaultValue = t0 === undefined ? false : t0;
  const match$ = useObservable(defaultValue);
  let t1;
  if ($[0] !== match$ || $[1] !== queryInput) {
    t1 = () => {
      if (!("matchMedia" in window && window.matchMedia)) {
        return;
      }
      const query = window.matchMedia(queryInput);
      const listener = function listener(event) {
        match$.set(event.matches);
      };
      match$.set(query.matches);
      query.addEventListener("change", listener);
      return () => query.removeEventListener("change", listener);
    };
    $[0] = match$;
    $[1] = queryInput;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useMount(t1);
  return match$;
}